var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3246",
  "data-name": "Group 3246",
  transform: "translate(-16 -240)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2292",
  "data-name": "Rectangle 2292",
  width: 16,
  height: 16,
  transform: "translate(16 240)",
  fill: "#afb6c0",
  opacity: 0
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M13.572,16H2.429a1.287,1.287,0,0,1-1.286-1.286V10.286a.643.643,0,1,1,1.286,0v4.428H13.572V10.286a.643.643,0,1,1,1.286,0v4.428A1.287,1.287,0,0,1,13.572,16ZM12.9,8.018a3.08,3.08,0,0,1-2.447-1.2,3.1,3.1,0,0,1-4.9-.012A3.1,3.1,0,0,1,0,4.919V1.286A1.287,1.287,0,0,1,1.286,0H14.714A1.287,1.287,0,0,1,16,1.286V4.919A3.1,3.1,0,0,1,12.9,8.018ZM11.089,1.286V4.919a1.812,1.812,0,1,0,3.625,0V1.286Zm-4.893,0V4.919a1.813,1.813,0,0,0,3.614.2c0-.058-.007-.121-.007-.2V1.286Zm-4.91,0V4.919a1.812,1.812,0,1,0,3.625,0V1.286Z",
  transform: "translate(16 240)",
  fill: "#aeb6c0"
}))));
export default __webpack_public_path__ + "static/media/prod.f5dd37f0.svg";
export { SvgComponent as ReactComponent };